import React, { useState, useEffect } from 'react';
import './KeyMessageForm.css';

const KeyMessageForm = ({ isOpen, onClose, onSubmit, themes, initialData }) => {
  const [formData, setFormData] = useState({
    title: '',
    supporting_statement: '',
    theme_id: '',
    tone_purpose: '',
    stage_tag: '',
    status: 'Draft'
  });

  useEffect(() => {
    if (initialData) {
      setFormData({
        title: initialData.title || '',
        supporting_statement: initialData.supporting_statement || '',
        theme_id: initialData.theme_id || '',
        tone_purpose: initialData.tone_purpose || '',
        stage_tag: initialData.stage_tag || '',
        status: initialData.status || 'Draft'
      });
    } else {
      setFormData({
        title: '',
        supporting_statement: '',
        theme_id: '',
        tone_purpose: '',
        stage_tag: '',
        status: 'Draft'
      });
    }
  }, [initialData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Add created_by_id from localStorage if available
    const user = localStorage.getItem('ezocmUser');
    let created_by_id = undefined;
    if (user) {
      try {
        const parsed = JSON.parse(user);
        created_by_id = parsed.id;
      } catch {}
    }
    // Key messages are theme-based only - no project relationship
    onSubmit({ ...formData, created_by_id });
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h3>{initialData ? 'Edit Key Message' : 'Create Key Message'}</h3>
          <button onClick={onClose} className="close-button">&times;</button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="title">Title</label>
            <input
              type="text"
              id="title"
              name="title"
              value={formData.title}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="supporting_statement">Supporting Statement</label>
            <textarea
              id="supporting_statement"
              name="supporting_statement"
              value={formData.supporting_statement}
              onChange={handleChange}
              required
              rows={4}
            />
          </div>

          <div className="form-group">
            <label htmlFor="theme_id">Theme</label>
            <select
              id="theme_id"
              name="theme_id"
              value={formData.theme_id}
              onChange={handleChange}
              required
            >
              <option value="">Select a theme</option>
              {themes.map(theme => (
                <option key={theme.id} value={theme.id}>
                  {theme.name}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="tone_purpose">Tone/Purpose</label>
            <input
              type="text"
              id="tone_purpose"
              name="tone_purpose"
              value={formData.tone_purpose}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="stage_tag">Stage Tag</label>
            <input
              type="text"
              id="stage_tag"
              name="stage_tag"
              value={formData.stage_tag}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="status">Status</label>
            <select
              id="status"
              name="status"
              value={formData.status}
              onChange={handleChange}
              required
            >
              <option value="Draft">Draft</option>
              <option value="Approved">Approved</option>
              <option value="Archived">Archived</option>
            </select>
          </div>

          <div className="modal-footer">
            <button type="button" onClick={onClose} className="button button-secondary">
              Cancel
            </button>
            <button type="submit" className="button button-primary">
              {initialData ? 'Save Changes' : 'Create'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default KeyMessageForm; 